var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-dropdown',_vm._g({staticClass:"actionButton",attrs:{"size":"md","right":"","text":"","variant":"dark"}},_vm.$listeners),[_c('template',{slot:"button-content"},[_c('v-icon',{attrs:{"name":_vm.icon,"width":"16"}})],1),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }